export default "__VITE_ASSET__aqrUsYJR__"